import { render, staticRenderFns } from "./bookingManifestGoodsInfo.vue?vue&type=template&id=1c70ac3a&"
import script from "./bookingManifestGoodsInfo.vue?vue&type=script&lang=js&"
export * from "./bookingManifestGoodsInfo.vue?vue&type=script&lang=js&"
import style0 from "./bookingManifestGoodsInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c70ac3a')) {
      api.createRecord('1c70ac3a', component.options)
    } else {
      api.reload('1c70ac3a', component.options)
    }
    module.hot.accept("./bookingManifestGoodsInfo.vue?vue&type=template&id=1c70ac3a&", function () {
      api.rerender('1c70ac3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/prePlanBookingJc/bookingManifestGoodsInfo.vue"
export default component.exports